import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
@Injectable()
export class EntityService {

    private api_url_get_countries_list = './api/server.php?cmd=GET_COUNTRIES_LIST';
    private api_url_get_payment_methods = './api/server.php?cmd=GET_PAYMENT_METHODS';
//    private api_url_get_all_entities = './api/server_tmp.php?cmd=GET_ALL_ENTITIES';
//    private api_url_insert_client = './api/server.php?cmd=INSERT_CLIENT';
//    private api_url_update_client = './api/server_tmp.php?cmd=UPDATE_CLIENT';
//    private api_url_delete_entity = './api/server_tmp.php?cmd=DELETE_ENTITY';
//   private api_url_get_entity_details = './api/server_tmp.php?cmd=GET_DETAILS_ENTITY';
    
    private api_url_get_all_entities = './api/server.php?cmd=GET_ALL_ENTITIES';
    private api_url_search_entity = './api/server.php?cmd=SEARCH_ENTITY'
    private api_url_insert_client = './api/server.php?cmd=INSERT_CLIENT';
    private api_url_update_client = './api/server.php?cmd=UPDATE_CLIENT';
    private api_url_delete_entity = './api/server.php?cmd=DELETE_ENTITY';
    private api_url_get_entity_details = './api/server.php?cmd=GET_DETAILS_ENTITY';

    constructor(private http: Http) {}

    InsertEntity(reference, name, code, address, city, country, component, interlocuteur, phone, portable, mail, siteweb, nif, stat, rcs, methods): Promise<Object> {
        return this.http.get(this.api_url_insert_client
            + '&reference=' + reference
            + '&name=' + name
            + '&code=' + code
            + '&address=' + address
            + '&city=' + city
            + '&country=' + country
            + '&component=' + component
            + '&interlocutor=' + interlocuteur
            + '&telephone=' + phone
            + '&portable=' + portable
            + '&mail=' + mail
            + '&siteweb=' + siteweb
            + '&nif=' + nif
            + '&stat=' + stat
            + '&rcs=' + rcs
            + '&methods=' + methods
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    UpdateEntity(id_entity, id_entity_information, reference, name, code, address, city, country, component, interlocuteur, phone, portable, mail, siteweb, nif, stat, rcs, methods): Promise<Object> {
        return this.http.get(this.api_url_update_client
            + '&id_entity=' + id_entity
            + '&id_entity_information=' + id_entity_information
            + '&reference=' + reference
            + '&name=' + name
            + '&code=' + code
            + '&address=' + address
            + '&city=' + city
            + '&country=' + country
            + '&component=' + component
            + '&interlocutor=' + interlocuteur
            + '&telephone=' + phone
            + '&portable=' + portable
            + '&mail=' + mail
            + '&siteweb=' + siteweb
            + '&nif=' + nif
            + '&stat=' + stat
            + '&rcs=' + rcs
            + '&methods=' + methods
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetCountriesList(): Promise<Object> {
        return this.http.get(this.api_url_get_countries_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetPaymentMethods(): Promise<Object> {
        return this.http.get(this.api_url_get_payment_methods)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetAllEntities(component: string): Promise<Object> {
        return this.http.get(this.api_url_get_all_entities
            + '&component=' + component
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    
    SearchEntity(component: string, name :string, ref: string, town: string): Promise<Object> {
        return this.http.get(this.api_url_search_entity
            + '&component=' + component + '&name=' + name + '&ref=' + ref + '&town=' + town
         )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    DeleteEntity(entity: any): Promise<Object> {
        return this.http.get(this.api_url_delete_entity
            + '&id_entity=' + entity.id_entity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetEntityDetails(id_entity: any): Promise<Object> {
        return this.http.get(this.api_url_get_entity_details
            + '&id_entity=' + id_entity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/entity.service.ts